import tzlookup from 'tz-lookup';

export class Timezone {
  static getTimezoneForLatLng({ lat, lng }) {
    return tzlookup(lat, lng);
  }
}
